<template>
  <div class="menu">
    <ul>
      <li v-if="isLoggedIn" @click="$emit('logout')">Logout</li>
    </ul>
  </div>
</template>

<script setup lang="ts">
import { useAppStore } from '../stores/appStore'
import { useUserProfileStore } from '../stores/userProfileStore'
import { ref, onMounted } from 'vue'
import { LoginRequired } from '../types/app/loginRequired'
import { State } from '../types/app/state'

const appStore = useAppStore()
const userProfileStore = useUserProfileStore()

const isLoggedIn = ref(false)
const showLogout = ref(false)
const showExportToPdf = ref(false)

onMounted(async () => {
  isLoggedIn.value = userProfileStore.isLoggedIn

  console.log(`UserProfileMenu - read state = ${appStore.currentState}`)
  //the application is in login state where login view is displayed
  if (appStore.currentState == State.Login) {
    showLogout.value = false
    showExportToPdf.value = false
  }

  if (
    appStore.currentState == State.Main &&
    appStore.configuration?.login.isLoginRequired == LoginRequired.SRRequiredOnly &&
    !userProfileStore.isLoggedIn
  ) {
    showLogout.value = false
    showExportToPdf.value = true
  }
  //application is in main state, login is disabled
  if (
    appStore.currentState == State.Main &&
    appStore.configuration?.login.isLoginRequired == LoginRequired.Never
  ) {
    showLogout.value = false
    showExportToPdf.value = true
  }

  if (
    appStore.currentState == State.Main &&
    (appStore.configuration?.login.isLoginRequired == LoginRequired.Always ||
      appStore.configuration?.login.isLoginRequired == LoginRequired.SRRequiredOnly) &&
    isLoggedIn.value
  ) {
    showLogout.value = true
    showExportToPdf.value = true
  }
})
</script>

<style scoped lang="scss">
.menu {
  position: absolute;
  top: 50px; /* below avatar */
  right: 0;
  background: var(--background-color);
  border: 1px solid #ddd;
  border-radius: 6px;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.15);
  z-index: 1000;

  min-width: 120px; /* 👈 ensure it’s wide enough */
  padding: 4px 0;
  box-sizing: border-box;
}

.menu ul {
  list-style: none;
  margin: 0;
  padding: 0;
}

.menu li {
  font-family: 'Noto Sans', sans-serif;
  font-size: 14px;
  padding: 8px 16px; /* 👈 spacing inside items */
  cursor: pointer;
  white-space: nowrap; /* 👈 keep text in one line */
}

.menu li:hover {
  background-color: #f2f2f2;
}

.menu li.divider {
  border-top: 1px solid #ddd;
  margin: 4px 0;
  padding: 0; /* no padding, just line */
  cursor: default; /* not clickable */
}
</style>
